var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex flex-col max-w-screen-2xl mx-auto px-2"},[_c('Logo',{staticClass:"p-2",attrs:{"size":"small"}}),_c('div',[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }